import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import { CashFlowAccount, CashFlowTransaction, CashFlowTransactionImbalance, ReceiptsPayslip } from '../models/CashFlow';
import Urls from './../api/Urls';

export function getTransactionsCashFlow(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.CASH_FLOW_TRANSACTIONS,
        params: params,
        parser: transactionsParser,
    }).get();
}

export function getAccountsCashFlow(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.CASH_FLOW_ACCOUNTS,
        params: params,
        parser: accountsParser,
    }).get();
}

export function getTransactionImbalanceCashFlow(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.CASH_FLOW_TRANSACTION_IMBALANCE,
        params: params,
        parser: transactionImbalanceParser,
    }).get();
}

export function createReceiptsPayslip(receiptsPayslip) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.CASH_FLOW_RECEIPTS_PAYSLIP_CREATE,
    }).post(receiptsPayslip.export());
}

const transactionsParser = (data) => ({
    result: (data.data.result || []).map(item => new CashFlowTransaction(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})

const accountsParser = (data) => ({
    result: (data.data.result || []).map(item => new CashFlowAccount(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})

const transactionImbalanceParser = (data) => ({
    result: (data.data.result || []).map(item => new CashFlowTransactionImbalance(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})